import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    useMediaQuery,
    useTheme
} from "@mui/material";
import PreciseItems from "../PreciseItems";
import {useTranslation} from "react-i18next";

interface Props {
    openPreciseDialog: boolean;
    setOpenPreciseDialog(open: boolean): void;
}

export default function DialogPreciseItems({openPreciseDialog, setOpenPreciseDialog}: Props) {
    const {t} = useTranslation();

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return(
        <Dialog
            open={openPreciseDialog}
            onClose={() => setOpenPreciseDialog(false)}
            maxWidth={false}
            fullScreen={fullScreen}
        >
            <DialogContent>
                <PreciseItems/>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpenPreciseDialog(false)} variant="contained" color="secondary">
                    {t("button_label_close")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}